import React, { useState } from "react";
import { compose } from 'ramda';

import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from '../style';
import LoyaltyLogin  from './Login';
import LoyaltyRegister  from './Register';

export const LoyaltyAccount = ({ initView }) => {

  const [view, setView] = useState(() => initView ? initView : 'login');

  const viewComponents = {
      login: LoyaltyLogin,
      register: LoyaltyRegister,
    };

  const render = () => {

    const Component = viewComponents[view];
    return <Component onView={ onView } />;
  }

  const onView = (view) => {

    setView(view);
  }

  return render();

}
export default compose(withThemeJSS({ styleFile,displayName:'style',link: true }), withContent('i18n'))(LoyaltyAccount);
